// import React from 'react';

// export const BottomNavBar = ({ 
//   activeTab, 
//   onNavigateHome,
//   onSearchClick,
//   onProfileClick,
//   onUpload,
//   isUploading,
//   isProfileSecondaryMode = false 
// }) => {
  
//   // --- Configuration ---
//   // We use their Gold theme but lower opacity for glass effect
//   const GLASS_BG = 'rgba(230, 197, 126, 0.60)'; 
//   const GLASS_BORDER = 'rgba(255, 255, 255, 0.4)';
//   const ACTIVE_PILL = 'rgba(130, 85, 30, 0.15)'; 
//   const SHADOW = '0 8px 32px 0 rgba(31, 38, 135, 0.10)';

//   // --- Styles ---
  
//   const containerStyle = {
//     position: 'fixed',
//     // Floats above the home indicator
//     bottom: 'calc(16px + env(safe-area-inset-bottom))', 
//     left: '50%',
//     // Centers the floating island
//     transform: 'translateX(-50%)',
//     // Responsive width with max constraint
//     width: 'min(90%, 380px)', 
//     height: '68px', // Taller to accommodate the rounded aesthetic
    
//     // THE APPLE GLASS EFFECT
//     background: GLASS_BG,
//     backdropFilter: 'blur(25px) saturate(180%)',
//     WebkitBackdropFilter: 'blur(25px) saturate(180%)',
//     borderRadius: '34px', // Fully rounded capsule ends
//     border: `1px solid ${GLASS_BORDER}`,
//     boxShadow: SHADOW,
    
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between', // Distribute space inside the capsule
//     padding: '0 8px', // Internal padding
//     zIndex: 1000,
//   };

//   const navButtonStyle = {
//     background: 'transparent',
//     border: 'none',
//     cursor: 'pointer',
//     // Touch target size
//     height: '52px', 
//     width: '52px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '50%', // Circular touch targets match the rounded bar
//     transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
//     WebkitTapHighlightColor: 'transparent',
//     position: 'relative'
//   };

//   // The "Active" state is now a subtle circle behind the icon
//   const activeStyle = {
//     background: ACTIVE_PILL,
//     transform: 'translateY(-2px)' // Slight lift
//   };

//   const profileButtonStyle = {
//     ...navButtonStyle,
//     ...(activeTab === 'profile' && !isProfileSecondaryMode ? activeStyle : {})
//   };

//   // Unified icon sizing for clean aesthetics
//   const iconBaseStyle = {
//     transition: 'transform 0.2s ease',
//     objectFit: 'contain'
//   };

//   return (
//     <div style={containerStyle}>
      
//       {/* Home Button */}
//       <button 
//         onClick={onNavigateHome} 
//         title="Home Feed"
//         style={{ ...navButtonStyle, ...(activeTab === 'home' ? activeStyle : {}) }}
//       >
//         <img 
//           src="/home_icon.jpg" 
//           alt="Home" 
//           style={{ 
//             ...iconBaseStyle, 
//             width: '28px', 
//             height: '28px', 
//             mixBlendMode: 'multiply', 
//             opacity: activeTab === 'home' ? 1 : 0.6 
//           }} 
//         />
//       </button>
      
//       {/* Search Button */}
//       <button 
//         onClick={onSearchClick} 
//         title="Search users"
//         style={{ ...navButtonStyle, ...(activeTab === 'search' ? activeStyle : {}) }}
//       >
//         <img 
//           src="/search.png" 
//           alt="Search" 
//           style={{ 
//             ...iconBaseStyle, 
//             width: '24px', 
//             height: '24px',
//             opacity: activeTab === 'search' ? 1 : 0.6 
//           }} 
//         />
//       </button>
      
//       {/* Upload Button (Centerpiece) */}
//       <label 
//         style={{ 
//           ...navButtonStyle, 
//           opacity: isUploading ? 0.5 : 1,
//           width: '60px', // Slightly larger center button
//           height: '60px'
//         }} 
//         title={isUploading ? 'Uploading...' : 'Upload images'}
//       >
//         {/* Center button gets a slight glow background for emphasis */}
//         <div style={{
//           position: 'absolute',
//           width: '44px', height: '44px',
//           borderRadius: '50%',
//           background: 'rgba(255,255,255,0.3)',
//           zIndex: -1
//         }} />
        
//         <img 
//           src="/upload.png" 
//           alt="Upload" 
//           style={{ 
//             ...iconBaseStyle, 
//             width: '26px', 
//             height: '26px' 
//           }} 
//         />
//         <input 
//           type="file" accept="image/*" 
//           onChange={onUpload} disabled={isUploading} multiple 
//           style={{ display: 'none' }} 
//         />
//       </label>
      
//       {/* Profile Button */}
//       <button 
//         onClick={onProfileClick} 
//         title="My Profile" 
//         style={profileButtonStyle}
//       >
//         <img 
//           src="/me.png" 
//           alt="My Profile" 
//           style={{ 
//             ...iconBaseStyle, 
//             width: '32px', 
//             height: '32px',
//             borderRadius: '50%', // Profile pics should be round
//             objectFit: 'cover',
//             border: activeTab === 'profile' ? '2px solid rgba(130,85,30,0.8)' : '2px solid transparent'
//           }} 
//         />
//       </button>

//     </div>
//   );
// };


import React, { memo } from 'react';

// --- Optimization: Inline SVGs ---
// These load instantly, scale infinitely, and require no network requests.
const HomeIcon = ({ active }) => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.5" : "2"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6, color: '#4A3B22' }}>
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const SearchIcon = ({ active }) => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.5" : "2"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6, color: '#4A3B22' }}>
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const UploadIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4A3B22" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
    <circle cx="8.5" cy="8.5" r="1.5"></circle>
    <polyline points="21 15 16 10 5 21"></polyline>
  </svg>
);

const ProfileIcon = ({ active, src }) => {
  // If user has a custom image, we use it, otherwise fallback to SVG
  if (src) {
    return (
      <img 
        src={src} 
        alt="Profile"
        style={{ 
          width: '30px', height: '30px', borderRadius: '50%', objectFit: 'cover',
          border: active ? '2px solid #82551E' : '2px solid transparent',
          transition: 'border 0.2s ease'
        }} 
      />
    );
  }
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={active ? "2.5" : "2"} strokeLinecap="round" strokeLinejoin="round" style={{ opacity: active ? 1 : 0.6, color: '#4A3B22' }}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  );
};

export const BottomNavBar = memo(({ 
  activeTab, 
  onNavigateHome,
  onSearchClick,
  onProfileClick,
  onUpload,
  isUploading,
  isProfileSecondaryMode = false 
}) => {
  
  // --- Haptic Feedback Helper ---
  // Gives a subtle physical "taptic" click on iPhones
  const handleHaptic = (callback) => (e) => {
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate(10); // Short, sharp tick
    }
    if (callback) callback(e);
  };

  // --- Styles ---
  // Define styles outside render or use constants to prevent garbage collection churn
  const GLASS_BG = 'rgba(230, 197, 126, 0.65)'; // Slightly higher opacity for legibility
  const SHADOW = '0 8px 32px 0 rgba(31, 38, 135, 0.15)';

  const containerStyle = {
    position: 'fixed',
    bottom: 'calc(20px + env(safe-area-inset-bottom))', // Lifted slightly more for modern iOS look
    left: '50%',
    transform: 'translateX(-50%) translateZ(0)', // translateZ forces GPU acceleration
    width: 'min(88%, 360px)', 
    height: '64px',
    
    // Premium Glass Effect
    background: GLASS_BG,
    backdropFilter: 'blur(20px) saturate(180%)',
    WebkitBackdropFilter: 'blur(20px) saturate(180%)', // Crucial for Safari/iOS
    borderRadius: '32px',
    
    // Border optimization: A semi-transparent white border looks cleaner than solid colors on glass
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: SHADOW,
    
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between', 
    padding: '0 12px',
    zIndex: 9999,
    
    // Interaction Optimizations
    userSelect: 'none',
    WebkitUserSelect: 'none',
    touchAction: 'manipulation',
  };

  // We inject a style tag for pseudo-classes (:active) which inline styles can't handle.
  // This creates that "squish" effect when you tap a button.
  const animationStyles = `
    .nav-btn {
      background: transparent;
      border: none;
      cursor: pointer;
      height: 48px;
      width: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: transform 0.1s cubic-bezier(0.4, 0, 0.2, 1), background 0.2s ease;
      -webkit-tap-highlight-color: transparent;
      position: relative;
    }
    .nav-btn:active {
      transform: scale(0.92);
    }
    .nav-btn.active-state {
      background: rgba(130, 85, 30, 0.1);
    }
    .upload-pulse {
      animation: pulse 2s infinite;
    }
    @keyframes pulse {
      0% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7); }
      70% { box-shadow: 0 0 0 10px rgba(255, 255, 255, 0); }
      100% { box-shadow: 0 0 0 0 rgba(255, 255, 255, 0); }
    }
  `;

  return (
    <>
      <style>{animationStyles}</style>
      <div style={containerStyle}>
        
        {/* Home */}
        <button 
          className={`nav-btn ${activeTab === 'home' ? 'active-state' : ''}`}
          onClick={handleHaptic(onNavigateHome)} 
          title="Home"
        >
          <HomeIcon active={activeTab === 'home'} />
        </button>
        
        {/* Search */}
        <button 
          className={`nav-btn ${activeTab === 'search' ? 'active-state' : ''}`}
          onClick={handleHaptic(onSearchClick)} 
          title="Search"
        >
          <SearchIcon active={activeTab === 'search'} />
        </button>
        
        {/* Upload (Center) */}
        <label 
          className={`nav-btn ${isUploading ? 'upload-pulse' : ''}`}
          style={{ 
            opacity: isUploading ? 0.6 : 1,
            width: '56px', 
            height: '56px',
            background: 'rgba(255, 255, 255, 0.25)', // Subtle backing for center button
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255,255,255,0.2)'
          }} 
          onClick={handleHaptic(null)} // Trigger haptic on click
        >
          <UploadIcon />
          <input 
            type="file" 
            accept="image/*" 
            onChange={onUpload} 
            disabled={isUploading} 
            multiple 
            style={{ display: 'none' }} 
          />
        </label>
        
        {/* Profile */}
        <button 
          className={`nav-btn ${activeTab === 'profile' && !isProfileSecondaryMode ? 'active-state' : ''}`}
          onClick={handleHaptic(onProfileClick)} 
          title="Profile"
        >
          {/* Pass a src prop here if you have a real user image url, e.g., src={user.avatarUrl} */}
          <ProfileIcon active={activeTab === 'profile'} src={null} /> 
        </button>

      </div>
    </>
  );
});

export default BottomNavBar;